import useMedia from 'use-media';
import StylishHeaderDetail from './stylishHeaderDetails';
import React from 'react';

function StylishHeader(prop) {
    const isLargeScreen = useMedia('(min-width: 601px)');
    const isSmallScreen = useMedia('(max-width: 600px)');

    return (
        <StylishHeaderDetail marginLeft={prop.marginLeft} isSmallScreen={isSmallScreen} isLargeScreen={isLargeScreen} headerText={prop.headerText} />
    )
}

export default StylishHeader;

